var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._v(" "+_vm._s(_vm.$options.name)+" "),_c('p',[_vm._v("TODO: setup view")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('b-btn',{on:{"click":_vm.logout}},[_vm._v("logout")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }